import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class StatisticService {
    constructor(private http: HttpClient) {}

    getTrainingStatisticsBetween(
        from: string,
        to: string,
        withComplementaryBilling: boolean
    ): Observable<any> {
        return this.http.get<any>(
            `/api/statistics/trainings/?from=${from}&to=${to}&includeComplementaryBilling=${withComplementaryBilling}`
        );
    }

    getTurnoverStatisticsDuringMonth(
        from: string,
        to: string,
        withComplementaryBilling: boolean
    ): Observable<any> {
        return this.http.get<any>(
            `/api/statistics/turnover/?from=${from}&to=${to}&includeComplementaryBilling=${withComplementaryBilling}`
        );
    }

    getCompanyStatisticsBetween(
        from: string,
        to: string,
        withComplementaryBilling: boolean
    ): Observable<any> {
        return this.http.get(
            `/api/statistics/companies/?from=${from}&to=${to}&includeComplementaryBilling=${withComplementaryBilling}`
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/statistic/statistic.service.ts